// src/theme.js
import { createTheme } from "@mui/material/styles";

export function buildTheme(mode) {
  const isDark = mode === "dark";

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? "#4d8ef0" : "#1565c0",
        dark: isDark ? "#1e5fc2" : "#0d47a1",
        light: isDark ? "#7aadff" : "#1976d2",
        contrastText: "#ffffff",
      },
      background: {
        default: isDark ? "#07101e" : "#eef2f7",
        paper: isDark ? "#0f1c2e" : "#ffffff",
      },
      divider: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.10)",
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h4: { fontWeight: 700, letterSpacing: "-0.5px" },
      h6: { fontWeight: 600, letterSpacing: "-0.25px" },
      subtitle2: { fontWeight: 600 },
    },
    shape: { borderRadius: 10 },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            boxShadow: isDark
              ? "0 2px 20px 0 rgba(0,0,0,0.55)"
              : "0 1px 8px 0 rgba(21,101,192,0.07)",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none" },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 6 },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? "#06101f" : "#1565c0",
            backgroundImage: "none",
            boxShadow: "none",
            borderBottom: `1px solid ${
              isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"
            }`,
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            "& .MuiTableCell-root": {
              fontWeight: 600,
              fontSize: "0.7rem",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            },
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarWidth: "thin",
            scrollbarColor: isDark
              ? "rgba(255,255,255,0.18) transparent"
              : "rgba(0,0,0,0.18) transparent",
          },
        },
      },
    },
  });
}
